import {_getElStyle} from "./Common_Fun";
import StaticDropCtl from "./js-drop";
import {AssertUtils,GoingUtils} from "goingutils";
import EditorTypeUtils from "../../../common/editorTypeUtils";

let SwitchCtl = {
    /**
     * 获取控件的html
     * @param formType 表单类型 分查询表单 和普通表单
     * @param item 选项
     * @param targetObj 可能是GoingForm对象 也可能是QueryForm对象
     */
    getHtml: function (formType, item, targetObj) {
        if (formType === "query") {
            return StaticDropCtl.getEditorHtml(item, targetObj);
        } else {
            return SwitchCtl.getEditorHtml(item, targetObj);
        }
    },
    //获取显示值
    getShowValue(curVal, inputItem) {
        var curLabel = curVal;
        //如果不为空 而且是数组
        if (AssertUtils.isNotNull(inputItem.items) && AssertUtils.isArray(inputItem.items)) {
            inputItem.items.forEach((itemObj) => {
                if (itemObj.value === curVal) {
                    curLabel = itemObj.label;
                }
            });

        }else{
            if(GoingUtils.parseBoolean(curVal)){
                curLabel="是";
            }else{
                curLabel="否";
            }
        }
        return curLabel;
    },
    /**
     * 获取编辑模式下的html代码
     * @param item
     * @param targetObj
     * @returns {string}
     */
    getEditorHtml: function ({label, items, id}, targetObj) {
        //获取相应激活的选项
        let activeItemObj = _getActiveSwitchItem(items);

        function _getCheckedState(activeItemObj) {
            if (activeItemObj["state"] === "open") {
                return "ivu-switch-checked";
            }
        }

        return `<div class="row  go-form-row flex-div">
                <div class="go-label" style="${_getElStyle(
            targetObj
        )}">${label}：</div> 
                <div class="go-content" style="position: relative;">
                  <input type="hidden" ctl="auto"  id="${
            targetObj.prefixCls
            }_${id}" value="${
            activeItemObj["value"]
            }" class="go-switch form-control">
                  <span class="ivu-switch ivu-switch-large ${_getCheckedState(
            activeItemObj
        )}">
                    <span class="ivu-switch-inner"> 
                        <span class="switch-slot" slot="${
            activeItemObj["state"]
            }">${activeItemObj["label"]}</span> 
                    </span>
                </span>
                </div></div>`;
    },
    setValue(prop, propValue, item, targetObj) {
        //获取相应激活的选项
        let activeItemObj = _getActiveSwitchItem(item.items);
        //获取未激活的选项
        let notActiveItemObj = _getNotActiveSwitchItem(
            item.items,
            activeItemObj.label
        );

        let inputElId = `${targetObj.prefixCls}_${item["id"]}`;

        if (activeItemObj.value === propValue) {
            $(`#${inputElId}`)
                .next()
                .find(".switch-slot")
                .attr("slot", "open");
            $(`#${inputElId}`)
                .next()
                .find(".switch-slot")
                .text(activeItemObj.label);
            $(`#${inputElId}`)
                .next()
                .addClass("ivu-switch-checked");
        } else {
            $(`#${inputElId}`)
                .next()
                .find(".switch-slot")
                .attr("slot", "close");
            $(`#${inputElId}`)
                .next()
                .find(".switch-slot")
                .text(notActiveItemObj.label);
            $(`#${inputElId}`)
                .next()
                .removeClass("ivu-switch-checked");
        }
        $("#" + inputElId).val(propValue);
    },
    /**
     * 初始化提交数据
     * @param item
     * @param targetObj 目标form对象
     * @param backJson 返回的数据
     * @param formType 表单类型
     */
    getSubmitData: function (
        item,
        targetObj,
        backJson,
        formType
    ) {
        if (formType === "query") {
            StaticDropCtl.getQuerySubmitData(item, targetObj, backJson);
        } else {
            this.getEditorSubmitData(item, targetObj, backJson);
        }
    },
    getQuerySubmitData: function (item, targetObj, backJson) {
        this.getEditorSubmitData(item, targetObj, backJson);
    },
    getEditorSubmitData: function (item, targetObj, backJson) {
        //时间
        let inputElId = `${targetObj.prefixCls}_${item["id"]}`;
        backJson[item["id"]] = $("#" + inputElId).val();
    },
    getRealValue(value, item) {
        return _getSwitchItemLabel(value, item["items"]);
    },
    clearData(item, formType, targetObj) {
        //如果是查询模式
        if (formType === "query") {
            StaticDropCtl.clearData(item, formType, targetObj);
        } else {
            let inputElId = `${targetObj.prefixCls}_${item["id"]}`;
            $("#" + inputElId).val("");
        }
    },
    initCtlEvent: function (
        parentObj,
        inputWidth,
        targetObj,
        vueObj
    ) {
        //初始化switch控件
        $(parentObj)
            .find(".go-switch")
            .each(function () {
                let inputId = $(this).attr("id");
                //获取当前定义的字段属性
                let {items} = (EditorTypeUtils.itemTemp)[inputId];
                //获取相应激活的选项
                let activeItemObj = _getActiveSwitchItem(items);
                //获取未激活的选项
                let notActiveItemObj = _getNotActiveSwitchItem(
                    items,
                    activeItemObj.label
                );

                $(this)
                    .next()
                    .click(function () {
                        //如果当前是选中状态 则设置为关闭状态
                        if ($(this).hasClass("ivu-switch-checked")) {
                            $(this)
                                .find(".switch-slot")
                                .attr("slot", "close");
                            $(this)
                                .find(".switch-slot")
                                .text(notActiveItemObj.label);
                            $("#" + inputId).val(notActiveItemObj["value"]);
                        } else {
                            $(this)
                                .find(".switch-slot")
                                .attr("slot", "open");
                            $(this)
                                .find(".switch-slot")
                                .text(activeItemObj.label);
                            $("#" + inputId).val(activeItemObj["value"]);
                        }
                        //设置form对象的变更事件
                        targetObj.executeEvent(
                            "change",
                            inputId,
                            $("#" + inputId).val(),
                            vueObj
                        );

                        $(this).toggleClass("ivu-switch-checked");
                        //设置vue的变更事件
                        if (vueObj != null) {
                            let elId = inputId.replaceAll(targetObj.prefixCls + "_", "");
                            if (vueObj != null) {
                                vueObj.$emit("change", {
                                    value: $("#" + inputId).val(),
                                    id: elId,
                                    elObj: $("#" + inputId)
                                });
                            }
                        }
                    });
            });
    }
};

function _getSwitchItemLabel(value, items) {
    let label = " ";
    items.forEach(function (item) {
        if (item.value === value) {
            label = item["label"];
        }
    });
    return label || " ";
}

//循环获取其中设置的默认选项 如果不存在默认选项 则设置第一项为默认项
function _getActiveSwitchItem(items) {
    if (AssertUtils.isArray(items)) {
        let activeItem = null;
        items.forEach(function (item) {
            if (item.active === true) {
                activeItem = item;
            }
        });
        //如果用户未设置激活的状态 则选择第一项作为激活项
        if (activeItem == null) {
            activeItem = items[0];
        }
        return activeItem;
    }
    return null;
}

//获取未激活的状态
function _getNotActiveSwitchItem(items, activeLabel) {
    let notActiveItem = null;
    if (items[0].label === activeLabel) {
        notActiveItem = items[1];
    } else {
        notActiveItem = items[0];
    }
    return notActiveItem;
}

export default SwitchCtl;



// WEBPACK FOOTER //
// ./goingsrc/jsCom/goForm/components/go-switch.js